import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box, Card, CardContent, Typography, List, ListItemButton, ListItemIcon,
  ListItemText, Grid, Stack, Paper, Divider,
} from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import DocumentPreview from './DocumentPreview';

export default function Reports() {
  const info = (() => {
    try { return JSON.parse(sessionStorage.getItem('companyInfo') || 'null'); }
    catch { return null; }
  })();
  const [documents, setDocuments] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (!info?.ID) return;
    axios
      .get('https://portal.peaksoftcon.com:8081/api/documents/', { params: { companyID: info.ID } })
      .then((res) => setDocuments(res.data || []))
      .catch((err) => console.error('Error fetching documents:', err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!info) return null;

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>
        {info.name} Raporları
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 1 }}>Belgeler</Typography>
              <Divider />
              <List dense sx={{ pt: 1 }}>
                {documents.length === 0 && (
                  <Typography color="text.secondary" align="center" sx={{ py: 3 }}>
                    Belge bulunamadı.
                  </Typography>
                )}
                {documents.map((doc) => (
                  <ListItemButton
                    key={doc.name}
                    selected={selected?.name === doc.name}
                    onClick={() => setSelected(doc)}
                    sx={{ borderRadius: 1, mb: 0.5 }}
                  >
                    <ListItemIcon sx={{ minWidth: 32 }}>
                      <DescriptionIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary={doc.name} primaryTypographyProps={{ variant: 'body2' }} />
                  </ListItemButton>
                ))}
              </List>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={8}>
          {selected ? (
            <DocumentPreview document={selected} />
          ) : (
            <Paper sx={{ p: 4, textAlign: 'center' }}>
              <Stack spacing={1} alignItems="center">
                <DescriptionIcon sx={{ fontSize: 48, color: 'text.disabled' }} />
                <Typography color="text.secondary">
                  Önizlemek için soldan bir belge seç.
                </Typography>
              </Stack>
            </Paper>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
